export default {
  init() {
    const recipeSteps = document.querySelectorAll('.ms-recipe-steps');

    if (recipeSteps && recipeSteps.length) {
      this.startListener(recipeSteps);
    }
  },
  startListener(recipeSteps) {
    recipeSteps.forEach(steps => {
      const recipeSections = steps.querySelectorAll('.ms-recipe-steps__section');

      recipeSections.forEach(recipeSection => {
        const list = recipeSection.querySelector('ol');

        list.setAttribute('aria-labelledby', `recipe-${recipeSection.dataset.index}`);
      });
    });
  },
}



// WEBPACK FOOTER //
// /private/var/www/Morton-Windsor/wp-content/themes/morton-salt/resources/assets/scripts/multisite/modules/recipe-steps.js